import { render, staticRenderFns } from "./EditUnidadAcademicaPage.vue?vue&type=template&id=2555ff59"
import script from "./EditUnidadAcademicaPage.js?vue&type=script&lang=js&external"
export * from "./EditUnidadAcademicaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports